import { REFER_AND_EARNS } from './actionTypes';

export const getReferAndEarnCode = (payload) => ({
  type: REFER_AND_EARNS,
  payload,
});
